import { Toast } from 'vant';
import wx from 'weixin-js-sdk';
import store from '@/store';
import { isWeChatBrowser } from '@/utils/is';
let timer = null;
const obj = {
  401: (msg, url) => {
    if (timer) return;
    Toast.loading({
      duration: 400,
      message: !isWeChatBrowser() ? '前往APP登录' : '',
    });
    const isReplacement = url.split('/').includes('vehicleReplacementConfig') || url.split('/').includes('vehicleReplacementClue');
    timer = setTimeout(() => {
      timer = null;
      if (store.getters.isYueye) {
        wx.miniProgram.reLaunch({
          url: '/pages/my/wxAuthorization/index?backPath=/packageB/BJWebview/index&h5Path=/replacement/index',
        });
      }
      else {
        const options = {
          path: isReplacement ? '/replacement/index' : '',
        };
        wx.miniProgram.reLaunch({
          url: `/pages/init/index?lastPage=/packageA/pages/web-h5/index&params=${JSON.stringify(options)}`,
        });
      }
    }, 400);
  },
  default: (msg) => {
    Toast.fail(msg);
  },
};

export default function(res) {
  setTimeout(() => {
    if (res.isNotToast) return;
    if (Object.prototype.hasOwnProperty.call(obj, res.code)) {
      obj[res.code](res.msg || res.data.msg, res.config.url);
      return;
    }
    if (res.data && Object.prototype.hasOwnProperty.call(obj, res.data.code)) {
      obj[res.data.code](res.msg || res.data.msg, res.config.url);
      return;
    }
    console.log(res);
    obj.default(res.msg || res.data.msg || '请求失败');
  }, 500);
}
